import { LOCAL_FAVORITES_KEY } from './enums';
import { isWindowDefined, retrieveUserFavorites } from './genericHelpers';

export const getLocalFavoritesItems = () => {
  if (isWindowDefined()) {
    try {
      const items = window.localStorage.getItem(LOCAL_FAVORITES_KEY);
      return items ? JSON.parse(items) : [];
    } catch (error) {
      console.error('Error parsing local favorites items:', error);
      return [];
    }
  }
  return [];
};

export const setLocalFavoritesItems = data => {
  if (isWindowDefined()) {
    try {
      window.localStorage.setItem(LOCAL_FAVORITES_KEY, JSON.stringify(data));
    } catch (error) {
      console.error('Error setting local favorites items:', error);
    }
  }
};

export const removeLocalFavorites = () => {
  return isWindowDefined() && window.localStorage.removeItem(LOCAL_FAVORITES_KEY);
};

export const getAllLocalFavorites = currentUser => {
  const userFavorites = retrieveUserFavorites(currentUser);
  const localFavorites = getLocalFavoritesItems();

  // Combine and deduplicate favorite IDs
  const allFavorites = [...new Set([...userFavorites, ...localFavorites])];

  return allFavorites;
};

export const upsertUserFavorites = ({ favorites = [], selectedFavoriteId }) => {
  if (!favorites.includes(selectedFavoriteId)) {
    favorites.push(selectedFavoriteId);
  }
  return favorites;
};

export const handleLocalFavoritesUpdate = selectedFavoriteId => {
  const localFavorites = getLocalFavoritesItems();
  const updatedFavorites = upsertUserFavorites({
    favorites: localFavorites,
    selectedFavoriteId,
  });
  setLocalFavoritesItems(updatedFavorites);
};

export const removeItemFromLocalFavorites = selectedFavoriteId => {
  const localFavorites = getLocalFavoritesItems();
  const updatedFavorites = localFavorites.filter(id => id !== selectedFavoriteId);

  setLocalFavoritesItems(updatedFavorites);
  return updatedFavorites;
};
